import {useState, useEffect, useRef} from "react";
import {SwalAlertClass} from "core/swalClass";
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from "chart.js";
import {Doughnut} from "react-chartjs-2";
import axiApi from "ApiCaller";
import WasteSelectorTypes from "../../components/waste-icons/WasteSelectorTypes";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughtModels = () => {
  const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
  const [data, setData] = useState([]);
  const [labels, setLabels] = useState([]);
  const [colors, setColors] = useState([]);
  const [total, setTotal] = useState(0);
  // a6c3d1
  // 0xa6
  const baseColor = "c3d1";
  //const color = useRef(a6c3d1)

  const DataGraph = {
    labels: labels,
    datasets: [
      {
        label: "Número de modelos",
        data: data,
        backgroundColor: colors,
        hoverOffset: 10,
      },
    ],
  };
  const OptionsGraph = {
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "rect",
          font: {
            size: 10,
          },
        },
      },
      title: {
        display: true,
        text: "Modelos de contenedores",
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            let value = tooltipItem.raw;
            let percentage = ((value / total) * 100).toFixed(2);
            return `${tooltipItem.label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  useEffect(() => {
    axiApi
      .get("/api/home/containers/models/")
      .then((resp) => {
        if (resp.data.status) {
          let labels = [];
          let values = [];
          let backgroud = [];
          let total = 0;
          let transSum = Math.trunc((255 - 40) / resp.data.containers.length); // num transparency
          let trans = 40; // min transparency
          resp.data.containers.forEach((waste, idx) => {
            labels.push(waste.model);
            values.push(waste.count);
            backgroud.push(`#229222${trans.toString(16)}`); // add transparency
            trans += transSum; // change transparency
            total += waste.count;
          });
          setLabels(labels);
          setData(values);
          setColors(backgroud);
          setTotal(total);
        } else {
          Alert.error(
            "Error in ContainerFraction.API",
            "Se ha encontrado un error en la carga del mapa."
          );
        }
      })
      .catch((error) => {
        console.log(error);
        Alert.error(
          "Error in ContainerFraction.API",
          "Se ha encontrado un error en la carga del mapa."
        );
      });
  }, []);

  return (
    <div className="border pb-3">
      <Doughnut data={DataGraph} options={OptionsGraph} />
    </div>
  );
};

export default DoughtModels;
